import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';
import { resourcePropertyMap } from '../../../model/his-resource-property-display.model';
import { ResourcePropertyDetail } from '../../../model/resource-property-detail.model';

/**
 * Marks a file that carries a configuration package with the name of that package.
 *
 * This is the Angular counterpart of the {@code confpackage} fragment of the JSF
 * {@code selectFile-metadata-icon.xhtml}.
 */
@Component( {
    standalone: false,
    selector: 'his-confpackage-icon',
    templateUrl: './his-confpackage-icon.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './his-confpackage-icon.component.css',
} )
export class HisConfpackageIconComponent {

    /** The properties of the {@code confpackage} category of the file. */
    readonly details = input.required<ResourcePropertyDetail[]>();

    /** The name of the configuration package, or `undefined` while it is not known. */
    protected readonly name = computed<string | undefined>( () =>
        resourcePropertyMap( this.details() ).get( 'name' ) || undefined
    );
}
